import { render, staticRenderFns } from "./FlexEasySetupSideNav.vue?vue&type=template&id=24242268&scoped=true&"
import script from "./FlexEasySetupSideNav.vue?vue&type=script&lang=js&"
export * from "./FlexEasySetupSideNav.vue?vue&type=script&lang=js&"
import style0 from "./FlexEasySetupSideNav.vue?vue&type=style&index=0&id=24242268&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24242268",
  null
  
)

export default component.exports